import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const sundayPollDetailsApi = createAsyncThunk(
    'auth/sundayPoll/detail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.sundayPollsAction(`poll-detail/${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: {}, loading: false, error: null, message: "" }
const sundayPollDetailsSlice = createSlice({
    name: 'sundayPoll detail',
    initialState: { result: {}, loading: false, error: null, message: "" },
    reducers: {
        resetSundayPoll: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(sundayPollDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(sundayPollDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(sundayPollDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetSundayPoll } = sundayPollDetailsSlice.actions;
export const sundayPollDetailsReducer = sundayPollDetailsSlice.reducer